import { IQuoteTemplateMutationsMock } from './mutations.mock.types';

export const mockItemMutations = (): IQuoteTemplateMutationsMock => ({
  //SERVICES
  SET_QUOTE_SERVICE_TEMPLATES: jest.fn(),
  ADD_QUOTE_SERVICE_TEMPLATE: jest.fn(),
  UPDATE_QUOTE_SERVICE_TEMPLATE: jest.fn(),
  REMOVE_QUOTE_SERVICE_TEMPLATE: jest.fn(),

  //FREIGHTS
  SET_QUOTE_FREIGHT_TEMPLATES: jest.fn(),
  ADD_QUOTE_FREIGHT_TEMPLATE: jest.fn(),
  UPDATE_QUOTE_FREIGHT_TEMPLATE: jest.fn(),
  REMOVE_QUOTE_FREIGHT_TEMPLATE: jest.fn(),

  //PAYMENT TERMS
  SET_QUOTE_PAYMENT_TERM_TEMPLATES: jest.fn(),
  ADD_QUOTE_PAYMENT_TERM_TEMPLATE: jest.fn(),
  UPDATE_QUOTE_PAYMENT_TERM_TEMPLATE: jest.fn(),
  REMOVE_QUOTE_PAYMENT_TERM_TEMPLATE: jest.fn(),

  //TERMS
  SET_QUOTE_TERM_TEMPLATES_ORDER: jest.fn(),
  SET_QUOTE_TERM_TEMPLATES: jest.fn(),
  ADD_QUOTE_TERM_TEMPLATE: jest.fn(),
  UPDATE_QUOTE_TERM_TEMPLATE: jest.fn(),
  REMOVE_QUOTE_TERM_TEMPLATE: jest.fn()
});
